import { useState, useEffect } from "react";
import { DropzoneArea } from 'material-ui-dropzone';
import { message, Modal } from "antd";
import { useHistory } from 'react-router-dom'

import Layout from "../Layout/Layout";
import Header from "../Components/Header";
import Map from "../Components/Map";
import CardSection from "../Components/CardSection";
import Achievement from "../Components/Achievement";
import QuoteForm from "../Components/QuoteForm";
import { url, header } from "../Constent/Constant";
import GetQuoteForm from "../Components/GetQuoteForm";

function ContactUs() {
  const [ContactData, setContactData] = useState('')
  const [ImageUpdate, setImageUpdate] = useState(null)
  const [ImageModal, setImageModal] = useState(false);
  const [UpdateId, setUpdateId] = useState('')
  const history = useHistory()

  const LoggedIn = localStorage.getItem('MS-Login')
  if (LoggedIn !== 'true') {
    history.push('/')
  }

  useEffect(() => {
    UpdateData()
  }, [])

  const UpdateData = () => {
    fetch(`${url}/page/viewpagedata`, {
      method: 'POST',
      body: JSON.stringify({
        name: "Contact Us"
      }),
      headers: header
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setContactData(data.doc)
      })
  }

  const OnFormFill = (ObjectData) => {
    if (ObjectData !== null) {
      fetch(`${url}/page/contactus`, {
        method: 'POST',
        body: JSON.stringify({
          data: {
            firstname: ObjectData.fName,
            lastname: ObjectData.lName,
            email: ObjectData.email,
            phone: ObjectData.phone
          }
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            message.success('Thank You')
          }
        })
    } else {
      console.error('Not fill Correctly')
    }
  }

  const UpdateImage = (DataObject) => {
    const Imagedata = new FormData();
    Imagedata.append('image', DataObject.image)
    Imagedata.append('id', DataObject.id)

    fetch(`${url}/page/updateimage`, {
      method: 'POST',
      body: Imagedata
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if (data.message === 'Success') {
          UpdateData()
        }
      })
  }

  const UpdateText = (DataObject) => {
    console.log(DataObject)
    if (DataObject !== '') {
      fetch(`${url}/page/updatedata`, {
        method: 'POST',
        body: JSON.stringify({
          id: DataObject.id,
          content: DataObject.text
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            UpdateData()
          }
        })
    }
  }

  const OnImageHandle = () => {
    if (ImageUpdate === null) {
      message.error('Insert Image')
    } else {
      UpdateImage({
        image: ImageUpdate,
        id: UpdateId
      })
      setImageModal(false);
    }
  };

  const showImageModal = (id) => {
    setImageModal(true);
    setUpdateId(id)
  };

  const handleCancel = () => {
    setImageModal(false);
  };

  return (
    <Layout>
      {ContactData && <Header
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        GetData={{
          imgId: ContactData.section1image1._id,
          headingId: ContactData.section1heading1._id
        }}
        Image={ContactData.section1image1.image} />}

      {ContactData && <div className='Contact-Container'>
        <div className='Commercial-Quote'>
          <div className='Commercial-Section'>
            <div className='Commercial-left-box'>
              <i onClick={() => showImageModal(ContactData.section2image1._id)} className="far fa-edit Edit-btn"></i>
              <img src={`${url}/api/getFile${ContactData.section2image1.image}`} alt="Img" />
            </div>
            <div className='Commercial-right-box'>
              <QuoteForm OnSubmit={OnFormFill} />
            </div>
          </div>
        </div>

        <CardSection
          UpdateText={UpdateText}
          UpdateImage={UpdateImage}
          CardData={{
            card1: {
              img: ContactData.section3image1.image,
              imgId: ContactData.section3image1._id,
              heading: ContactData.section3heading1.content,
              headingId: ContactData.section3heading1._id,
              para: ContactData.section3paragraph1.content,
              paraId: ContactData.section3paragraph1._id,
            },
            card2: {
              img: ContactData.section3image2.image,
              imgId: ContactData.section3image2._id,
              heading: ContactData.section3heading2.content,
              headingId: ContactData.section3heading2._id,
              para: ContactData.section3paragraph2.content,
              paraId: ContactData.section3paragraph2._id,
            },
            card3: {
              img: ContactData.section3image3.image,
              imgId: ContactData.section3image3._id,
              heading: ContactData.section3heading3.content,
              headingId: ContactData.section3heading3._id,
              para: ContactData.section3paragraph3.content,
              paraId: ContactData.section3paragraph3._id,
            }
          }} />

        <Achievement
          UpdateText={UpdateText}
          UpdateImage={UpdateImage}
          CardSection={{
            image: ContactData.section4image1.image,
            imageId: ContactData.section4image1._id,
            heading: ContactData.section4heading1.content,
            headingId: ContactData.section4heading1._id,
            para: ContactData.section4paragraph1.content,
            paraId: ContactData.section4paragraph1._id,
          }} />

        <Map />
        {
          ContactData && <GetQuoteForm UpdateImage={UpdateImage}
            imageID={ContactData.image._id} image={ContactData.image.image} />
        }

      </div>}

      {/* Update Image Modal */}
      <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
        <DropzoneArea
          filesLimit={1}
          acceptedFiles={['image/*']}
          dropzoneText={"Update Product Images"}
          onChange={(files) => {
            console.log('Files:', files[0])
            setImageUpdate(files[0])
          }}
        />
      </Modal>

    </Layout>
  );
}

export default ContactUs;
